import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import {
  AssetImage,
  AssetImageUrlPipe,
  ExternalLinkComponent,
  ImageThumbnailComponent,
} from '@web/shared/ui';

@Component({
  selector: 'app-footer-fourth-column',
  imports: [
    AssetImageUrlPipe,
    ExternalLinkComponent,
    ImageThumbnailComponent,
    NgOptimizedImage,
  ],
  templateUrl: './footer-fourth-column.component.html',
  styleUrl: './footer-fourth-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterFourthColumnComponent {
  protected readonly AssetImage = AssetImage;
}
